var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isHelpCenterEnabled && _vm.helpCenterArticleTitle)?_c('ViewportWrapper',{staticStyle:{"text-align":"right","font-size":"12px"}},[_c('UX1Link',{attrs:{"type":"primary","id":"helpcenter-link"},on:{"click":_vm.openHelpCenter}},[_vm._v(_vm._s(_vm.helpCenterArticleTitle))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }